export default __webpack_public_path__ + "static/media/group-of-scouts-in-helmets.87dabd96.jpg";